/* eslint-disable no-shadow */
const namespaced = true

const state = {
  cars: {},
  detail:null,
  mileage:null,
  order_number:null,
  registration_date:null,
  title:null,
  src:null,
  MileageCars: {},
}

const getters = {
  // 车辆原始数据
  carByCarId: state => (id) => {
    return state.cars[`raw-${id}`]
      ? state.cars[`raw-${id}`]
      : null
  },

  // titleByCarId
  // 车辆标题
  titleByCarId: (_, {carByCarId}) => (id) => {
    const car = carByCarId(id)

    if (!car) {
      return null
    }

    return car.title
  },
}

const actions = {}

const mutations = {
  // detail echarts图详细数据
  SET_MILEAGE: (state, detail) => {
    state.detail = detail
  },

  // ulr
  SET_URL: (state, src) => {
    state.src = src
  },

  // mileage
  SET_MIL: (state, mileage) => {
    state.mileage = mileage
  },

  // order_number
  SET_ORDER_NUMBER: (state, order_number) => {
    state.order_number = order_number
  },

  // title
  SET_TITLE: (state, title) => {
    state.title = title
  },

  // registration_date
  SET_DATE: (state, registration_date) => {
    state.registration_date = registration_date
  },
}

const Hunt = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}

export default Hunt

/* eslint-enable no-shadow */
